import * as awsExport from './aws-exports.json';

export default awsExport;
